<div class="tournament-container">
  <div class="tournament-brackets">
    <div class="bracket-container left-bracket">
      <ng-container *ngFor="let round of leftBracket; let roundIndex = index">
        <ul class="bracket bracket-{{roundIndex + 1}}" style="margin-left: 4px;">
          <li *ngFor="let group of round" class="team-item"
            [ngClass]="{'img-item': !group.GroupName && !evaluateGroups(group, round), 'img-item-empty': !group.GroupName && evaluateGroups(group, round),
            'highlight-current-user': shouldHighlightCurrentUser(group)}"
            [ngStyle]="!group.GroupName ? {'--margin-size': getMarginSize(leftBracket.length)} : null">
            <img class="profile-img" [src]="getImageSrc(group)" width="52" height="52" />
            <div class="group-container">
              <span class="participant-name" *ngIf="group.GroupName">{{group.GroupName}}</span>
              <span class="team-name" *ngIf="group.GroupName">{{group.ParentEmpGroupName}}</span>
              <span class="team-name" *ngIf="group.metricValue && gameStarted">{{group.metricValue}}</span>
              <span class="team-name" *ngIf="(!group.metricValue || group.metricValue === null || group.metricValue === undefined) && group.GroupName && (gameStarted || (!gameStarted && hasWinner))">
                ---
              </span>
            </div>
          </li>
        </ul>
      </ng-container>
    </div>
    <div class="bracket-final-container">
      <div class="card" *ngIf="!hasWinner && rightBracket.length > 0">
        <header class="card-header">
          <img class="profile-img" [src]="getImageSrc(null, 80)" width="80" height="80" style="margin-top: 2px;" />
        </header>
        <div class="card-body">
        </div>
      </div>
      <div
        [ngClass]="{'highlight-current-user': currentUser && winner.GroupName === currentUser.GroupName && winner.RoundNumber === currentUser.RoundNumber}"
        class="winner-card" *ngIf="hasWinner">
        <header class="winner-header">
          <div class="winner-icon">
            <div class="gtiWinnerBracketTournament"></div>
          </div>
          <img class="winner-img" [src]="getImageSrc(winner, 80)" />
        </header>
        <div class="winner-body">
          <div class="winner-title" cvLocalizedText langSection="Games" langKey="Champion">
            Champion
          </div>
          <div class="winner-name">
            {{ winner.GroupName }}
          </div>
          <div class="winner-team">
            {{ winner.ParentEmpGroupName }}
          </div>
          <div class="winner-stat">
            {{ winner.metricValue}}
          </div>
        </div>
      </div>
    </div>
    <div class="bracket-container right-bracket">
      <ng-container *ngFor="let round of rightBracket; let roundIndex = index">
        <ul class="bracket bracket-{{roundIndex + 1}}" style="margin-right: 4px;">
          <li *ngFor="let group of round" class="team-item"
            [ngClass]="{'img-item': !group.GroupName && !evaluateGroups(group, round), 'img-item-empty': !group.GroupName && evaluateGroups(group, round),
            'highlight-current-user': shouldHighlightCurrentUser(group)}"
            [ngStyle]="!group.GroupName ? {'--margin-size': getMarginSize(leftBracket.length)} : null">
            <img class="profile-img" [src]="getImageSrc(group)" width="52" height="52" />
            <div class="group-container">
              <span class="participant-name" *ngIf="group.GroupName">{{group.GroupName}}</span>
              <span class="team-name" *ngIf="group.GroupName">{{group.ParentEmpGroupName}}</span>
              <span class="team-name" *ngIf="group.metricValue && gameStarted">{{group.metricValue}}</span>
              <span class="team-name" *ngIf="(!group.metricValue || group.metricValue === null || group.metricValue === undefined) && group.GroupName && (gameStarted || (!gameStarted && hasWinner))">
                ---
              </span>
            </div>
          </li>
        </ul>
      </ng-container>
    </div>
  </div>
  <div class="cv-loader-container">
    <cv-loader size="medium" [overlay]="true" *ngIf="loading">
    </cv-loader>
  </div>
</div>
